import React, { useState, useEffect } from 'react';
import emailApi from '../services/emailApi';

interface ChartDataItem {
  label: string;
  sent: number;
  failed: number;
  pending: number;
}

interface StatsData {
  total: number;
  sent: number;
  failed: number;
  success_rate: number;
}

const StatsView: React.FC = () => {
  const [period, setPeriod] = useState(7);
  const [chartData, setChartData] = useState<ChartDataItem[]>([]);
  const [stats, setStats] = useState<StatsData>({ total: 0, sent: 0, failed: 0, success_rate: 0 });

  useEffect(() => {
    const load = async () => {
      try {
        const [chartResp, statsResp] = await Promise.all([
          emailApi.getChartData(period),
          emailApi.getDetailedStats(period)
        ]);
        setChartData((chartResp as Record<string, unknown>).data as ChartDataItem[] || []);
        const statsData = (statsResp as Record<string, unknown>).data as StatsData;
        if (statsData) setStats(statsData);
      } catch {
        // silently fail
      }
    };
    load();
  }, [period]);

  const maxValue = Math.max(...chartData.map(d => Math.max(d.sent || 0, d.failed || 0, d.pending || 0)), 1);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{ margin: 0, fontSize: '20px' }}>Statistici Detaliate</h2>
        <div style={{ display: 'flex', gap: '8px' }}>
          {[7, 30, 90].map(d => (
            <button key={d} onClick={() => setPeriod(d)} style={{
              padding: '6px 14px', border: '1px solid #ddd', borderRadius: '6px', cursor: 'pointer',
              backgroundColor: period === d ? '#3498db' : 'var(--card-bg, #1e293b)', color: period === d ? 'white' : 'var(--text-primary, #e2e8f0)', fontSize: '13px'
            }}>{d}z</button>
          ))}
        </div>
      </div>

      <div className="stats-grid-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px' }}>
        {[
          { label: 'Total', value: stats.total || 0, color: '#3498db' },
          { label: 'Trimise', value: stats.sent || 0, color: '#27ae60' },
          { label: 'Esuate', value: stats.failed || 0, color: '#e74c3c' },
          { label: 'Rata succes', value: `${stats.success_rate || 0}%`, color: '#f39c12' }
        ].map(s => (
          <div key={s.label} style={{ padding: '20px', borderRadius: '12px', backgroundColor: 'var(--card-bg, #1e293b)', border: '1px solid var(--border-color, #334155)', textAlign: 'center' }}>
            <div style={{ fontSize: '28px', fontWeight: 'bold', color: s.color }}>{String(s.value)}</div>
            <div style={{ fontSize: '13px', color: 'var(--text-secondary, #94a3b8)', marginTop: '4px' }}>{s.label}</div>
          </div>
        ))}
      </div>

      <div style={{ backgroundColor: 'var(--card-bg, #1e293b)', borderRadius: '12px', padding: '20px', border: '1px solid var(--border-color, #334155)' }}>
        <h3 style={{ marginTop: 0, fontSize: '16px' }}>Activitate - ultimele {period} zile</h3>
        {chartData.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: 'var(--text-secondary, #94a3b8)' }}>Nu sunt date disponibile</div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '4px', height: '200px', padding: '10px 0' }}>
            {chartData.map((item, idx) => (
              <div key={idx} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px', height: '100%', justifyContent: 'flex-end' }}>
                <div style={{ display: 'flex', gap: '1px', alignItems: 'flex-end', height: '100%' }}>
                  <div style={{ width: '8px', height: `${Math.max(((item.sent || 0) / maxValue) * 100, 2)}%`, backgroundColor: '#27ae60', borderRadius: '2px 2px 0 0' }} title={`Trimise: ${item.sent}`} />
                  <div style={{ width: '8px', height: `${Math.max(((item.failed || 0) / maxValue) * 100, 2)}%`, backgroundColor: '#e74c3c', borderRadius: '2px 2px 0 0' }} title={`Esuate: ${item.failed}`} />
                  <div style={{ width: '8px', height: `${Math.max(((item.pending || 0) / maxValue) * 100, 2)}%`, backgroundColor: '#f39c12', borderRadius: '2px 2px 0 0' }} title={`Programate: ${item.pending}`} />
                </div>
                <div style={{ fontSize: '9px', color: 'var(--text-secondary, #94a3b8)', transform: 'rotate(-45deg)', whiteSpace: 'nowrap', marginTop: '4px' }}>{item.label}</div>
              </div>
            ))}
          </div>
        )}
        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', marginTop: '12px', fontSize: '12px' }}>
          <span><span style={{ display: 'inline-block', width: '10px', height: '10px', backgroundColor: '#27ae60', borderRadius: '2px', marginRight: '4px' }} />Trimise</span>
          <span><span style={{ display: 'inline-block', width: '10px', height: '10px', backgroundColor: '#e74c3c', borderRadius: '2px', marginRight: '4px' }} />Esuate</span>
          <span><span style={{ display: 'inline-block', width: '10px', height: '10px', backgroundColor: '#f39c12', borderRadius: '2px', marginRight: '4px' }} />Programate</span>
        </div>
      </div>
    </div>
  );
};

export default StatsView;
